/* eslint-disable react/no-multi-comp */
import React, {Component} from 'react';
import moment from 'moment';
import classNames from 'classnames';
import strings from 'utils/strings';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPrint} from '@fortawesome/free-solid-svg-icons';

const InfoRow = (props) => {
	// eslint-disable-next-line no-undefined
	if (props.condition !== undefined && !props.condition) {
		return null;
	}
	return (
		<p className="info__row">
			<span className="info__label">{props.name}</span>
			<span className="info__value">{props.children || props.value}</span>
		</p>
	);
};
class TestUserInfo extends Component {
	render() {
		const {testResult} = this.props;
		const {testUser} = testResult;
		const isTestOwner = testResult.isTestOwner;
		const {
			testResult: {
				subtests: [{language}],
			},
		} = this.props;
		const monthString =
			language === 'nn' ? strings._props.nn.months : strings.months;

		let completeName = '<skjult navn>';

		if (testUser.firstName) {
			completeName = `${testUser.firstName} ${testUser.lastName}`;
		}

		return (
			<div>
				<div className="lit-input-information">
					<button
						className={classNames('print-hide', {
							'lit-btn2 see-more': true,
							'bg-tertiary': true,
						})}
						onClick={() => {
							window.print();
						}}
					>
						<FontAwesomeIcon
							size="lg"
							className="lit-icon-btns"
							icon={faPrint}
						/>

						<p className="lit-btns-txt">
							{strings.printInformation}
						</p>
					</button>
				</div>
				<div className="info">
					<InfoRow
						condition={isTestOwner}
						name={strings.name}
						value={completeName}
					/>
					<InfoRow
						condition={isTestOwner}
						name={strings.dateofbirth}
						value={`${moment(testUser.birthdate).format('LL')}`}
					/>
					<InfoRow
						name={strings.testdate}
						value={moment(testResult.completedAt).format('LL')}
					/>
					<InfoRow
						name={strings.age}
						value={strings.formatString(
							strings.ageYearsAndMonths,
							testUser.age.years,
							testUser.age.months,
							monthString
						)}
					/>
					<InfoRow name={strings.sex}>
						{testUser.gender === 'm' &&
							(testUser.age.years < 18
								? strings.boy
								: strings.male)}
						{testUser.gender === 'f' &&
							(testUser.age.years < 18
								? strings.girl
								: strings.female)}
						{testUser.gender === 'u' && strings.unspecified}
					</InfoRow>

					<div className="info__group info__group--education">
						<h3>{strings.education}</h3>
					</div>
					<InfoRow
						condition={isTestOwner}
						name={strings.countyColon}
						value={testUser.county}
					/>
					<InfoRow
						condition={isTestOwner}
						name={strings.municipalityColon}
						value={testUser.municipality}
					/>
					<InfoRow
						condition={isTestOwner}
						name={strings.schoolColon}
						value={testUser.school}
					/>
					<InfoRow name={`${strings.classGrade}: `}>
						{testUser.class === '0' && strings.lastYearBeforeSchool}
						{testUser.class === '1' && strings.grade1}
						{testUser.class === '2' && strings.grade2}
						{testUser.class === '3' && strings.grade3}
						{testUser.class === '4' && strings.grade4}
						{testUser.class === '5' && strings.grade5}
						{testUser.class === '6' && strings.grade6}
						{testUser.class === '7' && strings.grade7}
						{testUser.class === '8' && strings.grade8}
						{testUser.class === '9' && strings.grade9}
						{testUser.class === '10' && strings.grade10}

						{testUser.class === 'studiespesialisering' &&
							strings.studyPreparation}
						{testUser.class === 'yrkesfag' && strings.vocational}
						{testUser.class === 'bachelor' && strings.bachelor}
						{testUser.class === 'master' && strings.masterDegree}
						{testUser.class === 'phd' && strings.phdDegree}
					</InfoRow>
					<div className="info__group">
						<h3>{strings.homeLanugage}</h3>
						<InfoRow
							name={strings.grownUpMonoOrBilingual}
						>
							{testUser.languagesInHome === 'one' &&
								strings.oneLanguage}
							{testUser.languagesInHome === 'two' &&
								strings.twoLanguages}
							{testUser.languagesInHome === 'multiple' &&
								strings.multipleLanguages}
						</InfoRow>
					</div>
				</div>
			</div>
		);
	}
}

export default TestUserInfo;
